export class ClickTapHandler {
    constructor(element, clickCallback, tapCallback = null) {
        this.element = element;
        this.clickCallback = clickCallback;
        this.tapCallback = tapCallback || clickCallback;  // Use the clickCallback if no tapCallback is provided
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.TAP_THRESHOLD = 10; // Threshold to differentiate between tap and swipe
        this.isTouchDevice = this.detectTouchDevice();  // Improved touch detection

        // Bind event handlers
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onResize = Alpine.debounce(this.onResize.bind(this), 200);  // Debounced resize listener

        // Initialize event listeners
        this.addEventListeners();
        this.addResizeListener(); // Add resize listener to watch for screen changes
    }

    // Improved touch device detection
    detectTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    // Touchstart handler for tap detection
    onTouchStart( event ) {
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
    }

    // Touchend handler for tap detection
    onTouchEnd( event ) {
        const touchEndX = event.changedTouches[0].clientX;
        const touchEndY = event.changedTouches[0].clientY;
        const distX = Math.abs(touchEndX - this.touchStartX);
        const distY = Math.abs(touchEndY - this.touchStartY);

        // If movement is within the threshold, it's considered a tap
        if (distX < this.TAP_THRESHOLD && distY < this.TAP_THRESHOLD) {
            this.tapCallback( event );  // Invoke the tap callback function
        }
    }

    // Click handler for non-touch devices
    onClick( event ) {
        this.clickCallback( event );  // Invoke the click callback function
    }

    // Add the appropriate event listeners based on device type
    addEventListeners() {
        // console.log('Adding event listeners. Is touch device:', this.isTouchDevice);
        if (this.isTouchDevice) {
            this.element.addEventListener('touchstart', this.onTouchStart);
            this.element.addEventListener('touchend', this.onTouchEnd);
        } else {
            this.element.addEventListener('click', this.onClick);
        }
    }

    // Remove both click and touch event listeners
    removeEventListeners() {
        // console.log('Removing event listeners.');
        // Always remove both types of listeners
        this.element.removeEventListener('touchstart', this.onTouchStart);
        this.element.removeEventListener('touchend', this.onTouchEnd);
        this.element.removeEventListener('click', this.onClick);
    }

    // Resize handler (debounced)
    onResize() {
        const previousIsTouchDevice = this.isTouchDevice;
        this.isTouchDevice = this.detectTouchDevice();  // Redetect device type on resize

        // console.log('Resize detected, touchDevice:', this.isTouchDevice);

        // If device type has changed (from touch to non-touch or vice versa), reset listeners
        if (this.isTouchDevice !== previousIsTouchDevice) {
            // console.log('Device type changed, updating listeners.');
            this.removeEventListeners(); // Remove old listeners
            this.addEventListeners();    // Add new listeners based on updated device type
        }
    }

    // Add the resize listener
    addResizeListener() {
        window.addEventListener('resize', this.onResize);
    }

    // Remove the resize listener when no longer needed
    removeResizeListener() {
        window.removeEventListener('resize', this.onResize);
    }
}
